import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function AddEmployeeModal({
  open,
  onClose,
  formData,
  errors,
  submitError,
  isSubmitting,
  handleChange,
  handleSubmit,
  mode = "add",
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  if (!open) return null;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className="popup-overlay-employee">
      <div className="employee-register-form-container">
        <button className="popup-employee-close-button" onClick={handleClose}>
          ✕
        </button>
        <form className="employee-register-form" onSubmit={handleSubmit}>
          <h2>{mode === "edit" ? "Edit Employee" : "New Employee Registration"}</h2>
          <p style={{ color: "#4A5568" }}>
            {mode === "edit"
              ? "Update the employee information below"
              : "Please fill out the required information to register the employee"}
          </p>

          <div className="form-row-employee">
            <div className="form-group-employee">
              <label>First Name <span className="required-asterisk">*</span></label>
              <input
                type="text"
                name="firstName"
                placeholder="Ex. John"
                value={formData.firstName}
                onChange={handleChange}
              />
              {errors.firstName && <span className="add-device-error-message">{errors.firstName}</span>}
            </div>
            <div className="form-group-employee">
              <label>Last Name <span className="required-asterisk">*</span></label>
              <input
                type="text"
                name="lastName"
                placeholder="Ex. Doe"
                value={formData.lastName}
                onChange={handleChange}
              />
              {errors.lastName && <span className="add-device-error-message">{errors.lastName}</span>}
            </div>
          </div>

          {mode === "edit" ? (
            <div className="form-group-employee">
              <label>Contact No. <span className="required-asterisk">*</span></label>
              <input
                type="text"
                name="phone"
                placeholder="Ex. 1234567890"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <span className="add-device-error-message">{errors.phone}</span>}
            </div>
          ) : (
            <>
              <div className="form-row-employee">
                <div className="form-group-employee">
                  <label>Email <span className="required-asterisk">*</span></label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Ex. john@whygrene.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <span className="add-device-error-message">{errors.email}</span>}
                </div>
                <div className="form-group-employee">
                  <label>Contact No. <span className="required-asterisk">*</span></label>
                  <div className="combined-phone-input-container" style={{ display: "flex", gap: "8px" }}>
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="phone-country-select"
                      style={{ flex: "1 1 33%" }}
                    >
                      <option value="US">US</option>
                    </select>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Ex. 1234567890"
                      className="phone-number-input"
                      style={{ flex: "2 1 67%" }}
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.phone && <span className="add-device-error-message">{errors.phone}</span>}
                </div>
              </div>

              <div className="form-group-employee">
                <label>Password <span className="required-asterisk">*</span></label>
                <div className="input-with-icon">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <span className="icon" onClick={() => setShowPassword(!showPassword)}>
                    <FaEye className={showPassword ? "icon-visible" : "icon-hidden"} />
                    <FaEyeSlash className={showPassword ? "icon-hidden" : "icon-visible"} />
                  </span>
                </div>
                {errors.password && <span className="add-device-error-message">{errors.password}</span>}
              </div>

              <div className="form-group-employee">
                <label>Confirm Password <span className="required-asterisk">*</span></label>
                <div className="input-with-icon">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  <span className="icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    <FaEye className={showConfirmPassword ? "icon-visible" : "icon-hidden"} />
                    <FaEyeSlash className={showConfirmPassword ? "icon-hidden" : "icon-visible"} />
                  </span>
                </div>
                {errors.confirmPassword && <span className="add-device-error-message">{errors.confirmPassword}</span>}
              </div>

              <div className="form-group-employee">
                <label>Admin <span className="required-asterisk">*</span></label>
                <select
                  name="admin"
                  value={formData.admin}
                  onChange={handleChange}
                >
                  <option value="" disabled>----Select Yes or No----</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                {errors.admin && <span className="add-device-error-message">{errors.admin}</span>}
              </div>
            </>
          )}

          {submitError && <div className="error-message-box">{submitError}</div>}

          <button type="submit" className="register-button" disabled={isSubmitting}>
            {isSubmitting
              ? (mode === "edit" ? "Saving..." : "Creating...")
              : (mode === "edit" ? "Save Changes" : "Register")}
            {isSubmitting && <span className="spinner" />}
          </button>
        </form>
      </div>
    </div>
  );
}
